import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=3e17d617&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=3e17d617&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e17d617",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e17d617')) {
      api.createRecord('3e17d617', component.options)
    } else {
      api.reload('3e17d617', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=3e17d617&scoped=true", function () {
      api.rerender('3e17d617', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/orderDetail.vue"
export default component.exports